var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTissotDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1199 447.5"
    },
    xmlSpace: "preserve",
    viewBox: "188.95 173.55 821.08 100.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF0000;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#282828;}\n\t.st3{fill:#121212;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.85,
    y: 174.96,
    className: "st0",
    width: 97.57,
    height: 97.57
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "384.11,213.54 358.83,213.54 358.83,188.27 338.43,188.27 338.43,213.54 313.15,213.54      313.15,233.95 338.43,233.95 338.43,259.22 358.83,259.22 358.83,233.95 384.11,233.95    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 188.97,
    y: 174.96,
    className: "st2",
    width: 97.57,
    height: 97.57
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "273.24,188.27 247.96,188.27 227.56,188.27 202.28,188.27 202.28,207.78 227.56,207.78      227.56,259.22 247.96,259.22 247.96,207.78 273.24,207.78    "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "424.03,201.73 458.73,201.73 458.73,272.53 486.89,272.53 486.89,201.73 521.6,201.73 521.6,174.97     424.03,174.97   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.9,
    y: 174.96,
    className: "st3",
    width: 28.16,
    height: 97.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M639.5,213.3l-23.42-3.76c-3.62-0.56-7.39-1.81-7.39-5.71c0-4.74,5.3-7.25,13.1-7.25    c8.78,0,16.45,3.2,19.1,9.9l28.43-9.48c-6.83-17-27.74-23.42-45.72-23.42c-21.6,0-45.02,9.34-45.02,31.36    c0,17.84,15.33,25.51,33.59,28.43l21.74,3.48c6.83,1.11,9.76,4.04,9.76,7.25c0,4.88-6.83,6.83-15.33,6.83    c-12.68,0-20.21-4.46-23.97-13.24l-28.3,9.48c7.95,17.98,28.43,26.76,50.88,26.76c22.44,0,46.83-8.78,46.83-32.34    C673.79,226.96,664.31,217.34,639.5,213.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M747.1,213.3l-23.42-3.76c-3.62-0.56-7.39-1.81-7.39-5.71c0-4.74,5.3-7.25,13.1-7.25    c8.78,0,16.45,3.2,19.1,9.9l28.43-9.48c-6.83-17-27.74-23.42-45.72-23.42c-21.6,0-45.02,9.34-45.02,31.36    c0,17.84,15.33,25.51,33.59,28.43l21.74,3.48c6.83,1.11,9.76,4.04,9.76,7.25c0,4.88-6.83,6.83-15.33,6.83    c-12.68,0-20.21-4.46-23.97-13.24l-28.3,9.48c7.95,17.98,28.43,26.76,50.88,26.76c22.44,0,46.83-8.78,46.83-32.34    C781.39,226.96,771.91,217.34,747.1,213.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M848.38,173.57c-34.85,0-57.43,20.63-57.43,50.18s22.58,50.18,57.43,50.18c34.85,0,57.43-20.63,57.43-50.18    S883.22,173.57,848.38,173.57z M848.38,249.12c-18.12,0-27.74-11.57-27.74-25.37c0-13.8,9.62-25.37,27.74-25.37    c18.12,0,27.74,11.57,27.74,25.37C876.11,237.55,866.5,249.12,848.38,249.12z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "912.46,174.97 912.46,201.73 947.16,201.73 947.16,272.53 975.32,272.53 975.32,201.73     1010.03,201.73 1010.03,174.97   "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTissotDark);
export default __webpack_public_path__ + "static/media/tissot-dark.2224eeb9d33c8b06d9cbae9cac8ba3df.svg";
export { ForwardRef as ReactComponent };